// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"29adbeff","239":"6cac810e","667":"463a2435"}[chunkId] + ".chunk.js";
};